import { render, staticRenderFns } from "./EmailDetails.vue?vue&type=template&id=2252fd88&"
import script from "./EmailDetails.vue?vue&type=script&lang=js&"
export * from "./EmailDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports